var map = {
	"./ability.svg": 1302,
	"./arrow-down.svg": 1303,
	"./arrow-left-usual.svg": 1304,
	"./arrow-left.svg": 1305,
	"./arrow-right.svg": 1306,
	"./balcony.svg": 1307,
	"./bed.svg": 1308,
	"./booking-pending.svg": 1309,
	"./business.svg": 1310,
	"./chat.svg": 1311,
	"./check-circle.svg": 1312,
	"./check-square.svg": 1313,
	"./check.svg": 1314,
	"./checkmark-circle.svg": 1315,
	"./chevron-down.svg": 1316,
	"./chevron-left.svg": 1317,
	"./chevron-right.svg": 1318,
	"./chevron-up.svg": 1319,
	"./cleaning.svg": 1320,
	"./cleaning7x7.svg": 1321,
	"./close.svg": 1322,
	"./distance.svg": 1323,
	"./done.svg": 1324,
	"./double-arrow-right.svg": 1325,
	"./down.svg": 1326,
	"./dropdown.svg": 1327,
	"./dryclean.svg": 1328,
	"./expand.svg": 1329,
	"./facebook.svg": 1330,
	"./favorite.svg": 1331,
	"./fb-monophonic.svg": 1332,
	"./feedback.svg": 1333,
	"./fitness.svg": 1334,
	"./flash.svg": 1335,
	"./from-to.svg": 1336,
	"./google-color.svg": 1337,
	"./group.svg": 1338,
	"./guest.svg": 1339,
	"./halfstar.svg": 1340,
	"./hammam.svg": 1341,
	"./heart-folder.svg": 1342,
	"./home.svg": 1343,
	"./in-monophonic.svg": 1344,
	"./info.svg": 1345,
	"./instagram.svg": 1346,
	"./internet.svg": 1347,
	"./jacuzzi.svg": 1348,
	"./jacuzzionair.svg": 1349,
	"./kitchen.svg": 1350,
	"./language.svg": 1351,
	"./letter-filled.svg": 1352,
	"./letter.svg": 1353,
	"./location-filled.svg": 1354,
	"./location.svg": 1355,
	"./login.svg": 1356,
	"./long-arrow.svg": 1357,
	"./map.svg": 1358,
	"./meal-type-bb.svg": 1359,
	"./meal-type-hb.svg": 1360,
	"./meal.svg": 1361,
	"./media.svg": 1362,
	"./menu-burger.svg": 1363,
	"./menu.svg": 1364,
	"./messenger.svg": 1365,
	"./money-bag.svg": 1366,
	"./more-horizontal.svg": 1367,
	"./more.svg": 1368,
	"./my-bookings.svg": 1369,
	"./next-slider.svg": 1370,
	"./onair.svg": 1371,
	"./parking.svg": 1372,
	"./pets.svg": 1373,
	"./phone.svg": 1374,
	"./pool.svg": 1375,
	"./prev-slider.svg": 1376,
	"./property-benefit-1.svg": 1377,
	"./property-benefit-2.svg": 1378,
	"./property-benefit-3.svg": 1379,
	"./property-benefit-4.svg": 1380,
	"./property-benefit-5.svg": 1381,
	"./property-benefit-6.svg": 1382,
	"./property-hero-benefit-1.svg": 1383,
	"./property-hero-benefit-2.svg": 1384,
	"./property-hero-benefit-3.svg": 1385,
	"./reception.svg": 1386,
	"./reception24.svg": 1387,
	"./restaurant-michelin.svg": 1388,
	"./restaurant.svg": 1389,
	"./sauna.svg": 1390,
	"./share.svg": 1391,
	"./sign-in.svg": 1392,
	"./skiroom.svg": 1393,
	"./skis.svg": 1394,
	"./snowflake.svg": 1395,
	"./sort.svg": 1396,
	"./spa.svg": 1397,
	"./square-space.svg": 1398,
	"./star.svg": 1399,
	"./taxi.svg": 1400,
	"./telegram.svg": 1401,
	"./tie.svg": 1402,
	"./time.svg": 1403,
	"./tooltip.svg": 1404,
	"./transfer-benefit-1.svg": 1405,
	"./transfer-benefit-2.svg": 1406,
	"./transfer-benefit-3.svg": 1407,
	"./transfer-benefit-4.svg": 1408,
	"./transfer-benefit-5.svg": 1409,
	"./transfer-benefit-6.svg": 1410,
	"./transfer-benefit-7.svg": 1411,
	"./transfer-benefit-8.svg": 1412,
	"./transfer-benefit-9.svg": 1413,
	"./transfer-hero-benefit-1.svg": 1414,
	"./transfer-hero-benefit-2.svg": 1415,
	"./transfer-hero-benefit-3.svg": 1416,
	"./transfer-route.svg": 1417,
	"./tv.svg": 1418,
	"./users.svg": 1419,
	"./van.svg": 1420,
	"./viber.svg": 1421,
	"./view.svg": 1422,
	"./warning-circle.svg": 1423,
	"./water.svg": 1424,
	"./whatsapp.svg": 1425,
	"./wifi.svg": 1426,
	"./zoom-in-1.svg": 1427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1301;